// @ts-strict-ignore
import { isNil } from 'lodash';
import { RelatedCardComponent } from '@shared/scenes/workflows/config';
import { useWorkflowDispatch } from '@shared/scenes/workflows/context/context';

export interface LinkingOptionsHooks {
  onSelectFilteredComponent: (componentId: string) => void;
  onSelectLinkedComponent: (componentId: string) => void;
  onSelectWorkflow: (workflowTemplateId: string) => void;
}

export function useLinkingOptions(component: RelatedCardComponent): LinkingOptionsHooks {
  const dispatch = useWorkflowDispatch();
  const sortByComponents = component?.listDefault?.sortByComponents ?? [];
  const filterByComponents = component?.listDefault?.filterByComponents ?? [];
  const selectedWorkflowTemplateId = component?.workflowTemplateId;
  function onWorkflowTemplateSelected(workflowTemplateId: string) {
    if (selectedWorkflowTemplateId === workflowTemplateId) {
      dispatch({
        type: 'updateComponent',
        args: {
          ...component,
          default: { cardIds: [] },
          workflowTemplateId: null,
          listDefault: {
            filterByComponents: [],
            sortByComponents: [],
          },
        } as RelatedCardComponent,
      });
    } else {
      dispatch({
        type: 'updateComponent',
        args: {
          ...component,
          default: { cardIds: [] },
          workflowTemplateId: workflowTemplateId,
          listDefault: {
            filterByComponents: [],
            sortByComponents: [],
          },
        } as RelatedCardComponent,
      });
    }
  }

  function onSelectFilteredComponent(componentId: string) {
    if (filterByComponents[0]?.componentId === componentId) {
      dispatch({
        type: 'updateComponent',
        args: {
          ...component,
          listDefault: {
            filterByComponents: [],
            sortByComponents: sortByComponents,
          },
        },
      });
    } else {
      dispatch({
        type: 'updateComponent',
        args: {
          ...component,
          listDefault: {
            filterByComponents: [
              {
                componentId: componentId,
                value: null,
              },
            ],
            sortByComponents: sortByComponents,
          },
        },
      });
    }
  }

  function onSelectLinkedComponent(componentId: string) {
    const filteredBy = filterByComponents[0];
    const filteredByDynamicValue =
      filterByComponents[0]?.value?.containsCurrentWorkflowTemplateComponentValue;
    if (isNil(filteredBy)) {
      return;
    }
    if (!isNil(filteredByDynamicValue) && filteredByDynamicValue.componentId === componentId) {
      dispatch({
        type: 'updateComponent',
        args: {
          ...component,
          listDefault: {
            filterByComponents: [
              {
                componentId: filteredBy.componentId,
                value: {
                  containsCurrentUser: null,
                  containsNumber: null,
                  containsString: null,
                  stringWildcard: null,
                  dateIs: null,
                  dateRange: null,
                  dateTokenIs: null,
                  isEmpty: null,
                  numberIs: null,
                  containsCurrentWorkflowTemplateComponentValue: null,
                },
              },
            ],
            sortByComponents: sortByComponents,
          },
        },
      });
    } else {
      dispatch({
        type: 'updateComponent',
        args: {
          ...component,
          listDefault: {
            filterByComponents: [
              {
                componentId: filteredBy.componentId,
                value: {
                  containsCurrentUser: null,
                  containsNumber: null,
                  containsString: null,
                  stringWildcard: null,
                  dateIs: null,
                  dateRange: null,
                  dateTokenIs: null,
                  isEmpty: null,
                  numberIs: null,
                  containsCurrentWorkflowTemplateComponentValue: {
                    componentId: componentId,
                  },
                },
              },
            ],
            sortByComponents: sortByComponents,
          },
        },
      });
    }
  }

  return {
    onSelectFilteredComponent: onSelectFilteredComponent,
    onSelectLinkedComponent: onSelectLinkedComponent,
    onSelectWorkflow: onWorkflowTemplateSelected,
  };
}
